export default function KLTransportProblem() {
  const problems = [
    {
      icon: 'ri-traffic-light-line',
      title: 'Severe Traffic Congestion',
      stat: '53 hours/year',
      description: 'Average time wasted in traffic jams per commuter in Kuala Lumpur',
    },
    {
      icon: 'ri-car-line',
      title: 'Single-Occupancy Vehicles',
      stat: '85%',
      description: 'Of cars on KL roads carry only one person, wasting road capacity',
    },
    {
      icon: 'ri-bus-line',
      title: 'Unreliable Public Transport',
      stat: '30+ min',
      description: 'Average waiting time during peak hours at major LRT/bus stations',
    },
    {
      icon: 'ri-leaf-line',
      title: 'High Carbon Emissions',
      stat: '2.5M tons',
      description: 'Annual CO₂ emissions from private vehicles in Kuala Lumpur',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-red-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-alert-line text-red-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-red-700" style={{ fontFamily: "'Inter', sans-serif" }}>
              The Problem
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Kuala Lumpur's Transport Crisis
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Every day, millions of KL commuters face the same challenges: endless traffic jams, overcrowded public transport, and rising fuel costs. <strong className="font-bold">KLCarPool</strong> offers a smarter solution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:border-teal-300 transition-all hover:-translate-y-1"
            >
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${problem.icon} text-2xl text-red-600 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <div className="text-3xl font-bold text-teal-600 mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {problem.stat}
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {problem.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-50 to-teal-100 rounded-2xl p-8 border border-teal-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                The Solution: Daily Carpooling
              </h3>
              <p className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                By connecting commuters who travel the same route every day, <strong className="font-bold">KLCarPool</strong> reduces traffic by up to 75%, cuts commuting costs in half, and makes public transport delays a thing of the past.
              </p>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-center">
                <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>75%</div>
                <div className="text-xs text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>Less Traffic</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>50%</div>
                <div className="text-xs text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>Cost Savings</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>100%</div>
                <div className="text-xs text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>Reliable</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
